import {Component, Input} from '@angular/core';
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {TableService} from "../../../../core/services/table.service";
import {GeneralService} from "../../../../core/services/general.service";
import {NgIf} from "@angular/common";

@Component({
  selector: 'app-confirm',
  standalone: true,
  imports: [
    NgIf
  ],
  templateUrl: './confirm.component.html',
  styleUrl: './confirm.component.scss'
})
export class ConfirmComponent {
  @Input() confirmAction!: () => void;
  @Input() image: string;
  @Input() title: string;
  @Input() description: string;
  @Input() refModel: any;

  constructor(public modalService :NgbModal, private service: TableService, private generalService: GeneralService){
  }

  confirm() {
      this.confirmAction(); // Ejecuta la función pasada
  }

  close() {
    this.refModel.close();
  }
}
